import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import RightEditForm from './RightEditForm'
import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'
import SkeletonSingleSectionForm from '../../../../../features/components/FormDrawerWrapper/Skeletons/SkeletonSingleSectionForm'

import useManageDrawer from '../../../../../hooks/formHooks/useManageDrawer'
import useIsAdvancedPartnership from '../../../../../features/hooks/useIsAdvancedPartnership'

import { rightsListSelector } from '../../../../../modules/selectors/rights'
import { choicesAllocationUnitsWasLoadedSelector } from '../../../../../modules/selectors/choices'
import { getChoicesAllocationUnits } from '../../../../../modules/actions/choices'

import { RIGHT_EDIT } from '../../../../../constants/forms'
import { RIGHT_TYPE_DIGITAL, RIGHT_TYPE_POSTS } from '../fields'

const RightEdit = () => {
  const dispatch = useDispatch()
  const rights = useSelector(rightsListSelector)
  const choicesAllocationUnitsWasLoaded = useSelector(choicesAllocationUnitsWasLoadedSelector)

  const { selectedEditItemId, isFormOpen } = useManageDrawer({
    formName: RIGHT_EDIT
  })

  const isAdvancedPartnership = useIsAdvancedPartnership()

  const editRightData = useMemo(
    () => rights.find(right => right.id === Number(selectedEditItemId)),
    [rights, selectedEditItemId]
  )

  const advancedPartnershipFormTitle = useMemo(() => {
    switch (editRightData?.['right_type']) {
      case RIGHT_TYPE_DIGITAL:
        return 'Edit campaign'
      case RIGHT_TYPE_POSTS:
        return 'Edit report'
      default:
        return 'Edit'
    }
  }, [editRightData])

  const editRightId = editRightData && editRightData.id

  useEffect(() => {
    if (isFormOpen && !choicesAllocationUnitsWasLoaded) {
      dispatch(getChoicesAllocationUnits())
    }
  }, [dispatch, isFormOpen, choicesAllocationUnitsWasLoaded])

  return (
    <FormDrawerWrapper
      formName={RIGHT_EDIT}
      SkeletonFormComponent={SkeletonSingleSectionForm}
      showOpenButton={false}
      isInitialDataLoading={!editRightData}
      title={isAdvancedPartnership ? advancedPartnershipFormTitle : 'Edit right'}
      isFormLoading={!editRightData}
    >
      <RightEditForm editRightId={editRightId} editRightData={editRightData} />
    </FormDrawerWrapper>
  )
}

export default RightEdit
